import { render, staticRenderFns } from "./CollapseInfos.vue?vue&type=template&id=a581ec2c&scoped=true"
import script from "./CollapseInfos.vue?vue&type=script&lang=js"
export * from "./CollapseInfos.vue?vue&type=script&lang=js"
import style0 from "./CollapseInfos.vue?vue&type=style&index=0&id=a581ec2c&prod&lang=less"
import style1 from "./CollapseInfos.vue?vue&type=style&index=1&id=a581ec2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a581ec2c",
  null
  
)

export default component.exports